import { NodeEventsTypes } from '@treedis/tour-loader';
import { useRef } from 'react';
import { getClosestSweepFromObject } from '@/components/flows/utils/getClosestSweep';
import { getDetailedRouteDistance } from '@/utils/getDistance';
import { NavigationType } from '../NavigationIntroScreen/components/Popup/NavigationIntroChoicePopup';

export const useDetailedRoutes = ({ pathFinderLine, navigationSettings, startingPoint, targetLocation, allSweeps, THREE, navType }) => {
  const detailedRoutesRef = useRef([]);
  const detailedRoutes = detailedRoutesRef.current;

  const resetDetailedRoutes = () => {
    detailedRoutesRef.current = [];
    pathFinderLine?.reset();
  };

  pathFinderLine?.on(NodeEventsTypes.NAVIGATION_PATH_RENDER_COMPLETE, (data) => {
    const { detailedRouteEnabled } = navigationSettings;
    const { path } = data;
    if (
      (detailedRouteEnabled && !detailedRoutes.length && !!path.length && startingPoint && targetLocation) ||
      (startingPoint && targetLocation && detailedRoutes[detailedRoutes?.length - 1]?.id !== targetLocation?.id) ||
      (startingPoint && targetLocation && detailedRoutes[0]?.id !== startingPoint?.id)
    ) {
      const pathDirectionSigns = pathFinderLine.getPathDirectionSigns();
      const teleportPoints = pathFinderLine.getTeleportPoints();
      const foundTpGroupsIds = [];

      path.forEach((p, i) => {
        const foundPathSign = pathDirectionSigns.find((d) => {
          return d.id === p.data.id;
        });
        if (i === 0) {
          let detail = null;
          if (startingPoint.tag) {
            const { closestSweep } = getClosestSweepFromObject({ allSweeps, target: startingPoint.tag });
            detail = { ...closestSweep, tag: startingPoint.tag };
          } else {
            detail = startingPoint;
          }
          detailedRoutes.push({ ...detail });
        }

        if (foundPathSign) {
          const foundTpGroup = teleportPoints.find((tp) => tp.pointNodes?.find((tpn) => tpn?.sweep === p.data.id));
          // const foundTpGroupByEnd = teleportPoints.find((tp) => tp.pointNodes[1]?.sweep === p.data.id);
          const latestItem = detailedRoutes[detailedRoutes.length - 1];
          const startIndex = path.findIndex((item) => item.data.id === latestItem.id);
          const endIndex = path.findIndex((item) => item.data.id === foundPathSign.id);
          const resultArray = path.slice(startIndex, endIndex + 1);
          const distance = getDetailedRouteDistance(resultArray, THREE);
          // if (!foundTpGroupByStart && !foundTpGroupByEnd) {
          if (!foundTpGroup) {
            detailedRoutes.push({
              ...foundPathSign,
              distance: distance.toFixed(1),
            });
          }
        }
        if (teleportPoints.length > 0 && navType !== NavigationType.NoStairs) {
          const foundTpGroup = teleportPoints
            .filter((tp) => (tp.type === 'elevator' && navType === NavigationType.Shortest) || (tp.type === 'stairway' && navType === NavigationType.NoElevators))
            .find((tp) => {
              // return tp.pointNodes[0]?.sweep === p.data.id || tp.pointNodes[1]?.sweep === p.data.id;
              return tp.pointNodes?.find((tpn) => tpn?.sweep === p.data.id);
            });
          if (foundTpGroup && !foundTpGroupsIds.includes(foundTpGroup.id)) {
            foundTpGroupsIds.push(foundTpGroup.id);
            const startingTpNode = foundTpGroup.pointNodes.filter((tp) => tp.sweep === p.data.id);
            const endTpNode = foundTpGroup.pointNodes.filter((tp) => tp.sweep === path[i + 1]?.data.id);
            const endTpTurnSign = pathDirectionSigns.find((d) => {
              return d.id === endTpNode[0]?.sweep;
            });

            if (startingTpNode && endTpNode) {
              const latestItem = detailedRoutes[detailedRoutes.length - 1];
              const startIndex = path.findIndex((item) => item.data.id === latestItem.id);
              const endIndex = path.findIndex((item) => item.data.id === p.data.id);
              const resultArray = path.slice(startIndex, endIndex + 1);
              const distance = getDetailedRouteDistance(resultArray, THREE);
              detailedRoutes.push({ ...p.data, tpGroupStart: { ...startingTpNode, type: foundTpGroup.type }, distance: distance.toFixed(1) });
              detailedRoutes.push({ ...path[i + 1]?.data, tpGroupEnd: { ...endTpNode, type: foundTpGroup.type, turn: endTpTurnSign?.turn } });
            }
          }
        }
        if (p.data.isMandatory) {
          const latestItem = detailedRoutes[detailedRoutes.length - 1];
          const startIndex = path.findIndex((item) => item.data.id === latestItem.id);
          const endIndex = path.findIndex((item) => item.data.id === p.data.id);
          const resultArray = path.slice(startIndex, endIndex + 1);
          const distance = getDetailedRouteDistance(resultArray, THREE);
          detailedRoutes.push({
            ...p.data,
            distance: distance.toFixed(1),
          });
        }
        if (i === path.length - 1) {
          const latestItem = detailedRoutes[detailedRoutes.length - 1];

          const startIndex = path.findIndex((item) => item.data.id === latestItem.id);
          const endIndex = path.findIndex((item) => item.data.id === p.data.id);
          const resultArray = path.slice(startIndex, endIndex + 1);
          const distance = getDetailedRouteDistance(resultArray, THREE);
          detailedRoutes.push({ ...targetLocation, distance: distance.toFixed(1), isFinish: true });
        }
      });
    }
  });

  pathFinderLine?.on(NodeEventsTypes.NAVIGATION_COMPLETE, () => {
    resetDetailedRoutes();
  });

  return { detailedRoutes, resetDetailedRoutes };
};
